
import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import XJackpotDetails from '@core/models/games/XJackpotDetails';
import IXJackpotDto from './dtos/IXJackpotDto';

export default class XJackpotDetailsMapper extends AbstractMapper<IXJackpotDto, XJackpotDetails> {
    createTargetObject(dto: IXJackpotDto): XJackpotDetails {
        const details = new XJackpotDetails();
        details.currentValue = dto.currentVal;
        details.incrementPerSecond = dto.growthpersec;
        return details;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/game/XJackpotDetailsMapper.ts